// extracted by mini-css-extract-plugin
export default {"categorySelectButton":"B9UgUbQa2Al_c4MYqu1U"};